// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sa2LO","content":"styles_content__s2Nln","centered-row":"styles_centered-row__pwsSz"};